// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subMilliseconds as fn } from "../subMilliseconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subMilliseconds = convertToFP(fn, 2);

// Fallback for modularized imports:
export default subMilliseconds;
